// @ts-ignore

import { defineNuxtPlugin } from '#app'
import printJS from 'print-js'
export default defineNuxtPlugin((nuxtApp: any) => {
    nuxtApp.vueApp.component('v-printjs', printJS)
})
